import { Loading } from "@components/common";
import { CommonProductPage } from "@product-pages/components/common";

export const LoadingPage = () => (
  <CommonProductPage>
    <Loading />
  </CommonProductPage>
);
